// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M10.54 2.16A3 3 0 0 1 12.93 3.03L20.75 10.85A3 3 0 0 1 20.75 15.09L15.09 20.75A3 3 0 0 1 10.85 20.75L3.03 12.93A3 3 0 0 1 2.16 10.54L2.63 5.36A3 3 0 0 1 5.35 2.64ZM10.86 8.02A2 2 0 1 0 8.03 10.85 2 2 0 0 0 10.86 8.02"/>';

/** Price Tag (commerce). */
const icon: IconData = {
  id: "price-tag",
  name: "Price Tag",
  category: "commerce",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path fill="none" stroke="currentColor" stroke-width="2" d="M3.74 12.22A2 2 0 0 1 3.16 10.63L3.63 5.44A2 2 0 0 1 5.44 3.63L10.63 3.16A2 2 0 0 1 12.22 3.74L20.04 11.56A2 2 0 0 1 20.04 14.39L14.38 20.05A2 2 0 0 1 11.55 20.05Z"/><path fill="none" stroke="currentColor" stroke-width="2" d="M10.85 8.03A2 2 0 1 1 8.02 10.86 2 2 0 0 1 10.85 8.03Z"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M10.54 2.16L11.62 2.28 12.03 2.43 12.93 3.03 20.87 11 21.3 11.65 21.45 12.01 21.61 12.78V13.17L21.45 13.94 21.3 14.3 20.75 15.1 14.94 20.88 14.29 21.32 13.93 21.46 13.16 21.62H12.77L12 21.46 11.64 21.32 10.84 20.76 2.9 12.76 2.43 12.03 2.28 11.62 2.16 10.54 2.67 5.18 2.85 4.5 3.39 3.63 4.19 3 4.5 2.85 5.35 2.63Z"/></g><path fill="none" stroke="currentColor" stroke-width="2" d="M3.74 12.22A2 2 0 0 1 3.16 10.63L3.63 5.44A2 2 0 0 1 5.44 3.63L10.63 3.16A2 2 0 0 1 12.22 3.74L20.04 11.56A2 2 0 0 1 20.04 14.39L14.38 20.05A2 2 0 0 1 11.55 20.05Z"/><path fill="none" stroke="currentColor" stroke-width="2" d="M10.85 8.03A2 2 0 1 1 8.02 10.86 2 2 0 0 1 10.85 8.03Z"/>',
    },
  },
  animation: () => import("../animations/price-tag.js"),
};

export default icon;
